

















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import DxFileManager from 'devextreme-vue/file-manager'
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box'
import { DxPopup } from 'devextreme-vue'
import { DxButton } from 'devextreme-vue/ui/button'
import CustomFileSystemProvider from 'devextreme/file_management/custom_provider'
import FileManagementService from '@/services/file-management-service'
import { Message } from 'element-ui'
import UserManagerService from '@/services/data/user_manager'
import AuthService from '@/services/auth_service'
import DocumentHistory from './document-history.vue'

interface FileSystemItem {
  name: string
  isDirectory: boolean
  size?: number
  key?: string
  pathKeys?: string[]
  thumbnail?: string
  relativeName?: string
  parentPath?: string
}

interface APIFileItem {
  name: string
  isDirectory: boolean
  size?: number
  items?: APIFileItem[]
  error?: boolean
  props?: {
    author?: string
    date_created?: string
    date_modified?: string
    size?: string
  }
}

interface PreviewState {
  visible: boolean
  type: null | 'pdf' | 'excel' | 'image' | 'text' | 'archive' | 'unsupported'
  fileName: string
  excelRows: {cells: {idx: number, value: any}[], idx:number}[]
  imageSrc: string
  textContent: string
  pdfSrc: string
}

@Component({
  name: 'FileManager',
  components: { 
    DxFileManager,
    DxTextBox,
    DxTextBoxButton,
    DxPopup,
    DxButton,
    DocumentHistory
  }
})
export default class extends Vue {
  fileSystemProvider: any = null
  fullFileTree: APIFileItem | null = null
  searchQuery: string = ''
  searchResultsCount: number = 0
  showHistoryPopup: boolean = false

  preview: PreviewState = {
    visible: false,
    type: null,
    fileName: '',
    excelRows: [],
    imageSrc: '',
    textContent: '',
    pdfSrc: '',
  }

  get userHasAnyFileAccess(): boolean {
    const access = this.userService.current_user?.storage_access
    return access === 'read_only' || access === 'read_and_edit'
  }

  get isSearching(): boolean {
    return this.searchQuery.trim().length >= 3
  }

  get clearButtonOptions() {
    return {
      icon: 'clear',
      stylingMode: 'text' as const,
      onClick: () => this.clearSearch()
    }
  }

  get permissions() {
    if (!this.userService.current_user) {
      return {
        create: false,
        copy: false,
        move: false,
        delete: false,
        rename: false,
        download: false,
        upload: false
      }
    }
    
    if (this.userService.current_user.storage_access === 'read_only') {
      return {
        create: false,
        copy: false,
        move: false,
        delete: false,
        rename: false,
        download: true,
        upload: false
      }
    } else if (this.userService.current_user.storage_access === 'read_and_edit') {
      return {
        create: true,
        copy: true,
        move: true,
        delete: true,
        rename: true,
        download: true,
        upload: true
      }
    } else {
      return {
        create: false,
        copy: false,
        move: false,
        delete: false,
        rename: false,
        download: false,
        upload: false
      }
    }
  }

  itemViewConfig = {
    mode: 'details',
    details: {
      columns: [
        {
          dataField: 'thumbnail',
          caption: '',
          width: 50,
          alignment: 'center'
        },
        {
          dataField: 'name',
          caption: 'Имя файла',
          alignment: 'left'
        },
        {
          dataField: 'props.author',
          caption: 'Автор',
          alignment: 'left'
        },
        {
          dataField: 'props.date_modified',
          caption: 'Дата изменения',
          alignment: 'left'
        },
        {
          dataField: 'props.date_created',
          caption: 'Дата создания',
          alignment: 'left'
        },
        {
          dataField: 'props.size',
          caption: 'Размер',
          alignment: 'left'
        },
      ]
    }
  }

  public userService = UserManagerService
  public authService = AuthService

  get isAdmin(): boolean {
    return this.authService.isAdmin()
  }

  async mounted() {
    await this.loadFullFileTree()
    this.initializeFileSystemProvider()
  }

  async loadFullFileTree() {
    try {
      const res = await FileManagementService.getFileTree('/')
      if (!res || res.error) throw new Error('Ошибка загрузки дерева файлов')
      this.fullFileTree = res
    } catch (e) {
      Message.error('Не удалось загрузить дерево файлов')
    }
  }

  findItemsByPath(path: string): APIFileItem[] {
    if (!this.fullFileTree) return []
    if (path === '/' || path === '') return this.fullFileTree.items || []

    const pathParts = path.split('/').filter(Boolean)
    let currentItems = this.fullFileTree.items || []

    for (const part of pathParts) {
      const foundItem = currentItems.find((item) => item.name === part && item.isDirectory)
      if (!foundItem) {
        console.warn('[FileManager] Папка не найдена:', part)
        return []
      }
      currentItems = foundItem.items || []
    }
    return currentItems
  }

  findParentByPath(path: string): APIFileItem | null {
    if (!this.fullFileTree) return null
    if (path === '/' || path === '') return null

    const pathParts = path.split('/').filter(Boolean)
    if (pathParts.length === 0) return this.fullFileTree

    let currentItem = this.fullFileTree
    for (let i = 0; i < pathParts.length - 1; i++) {
      const part = pathParts[i]
      const items = currentItem.items || []
      const foundItem = items.find((item) => item.name === part && item.isDirectory)
      if (!foundItem) {
        console.warn('[FileManager] Родитель не найден:', part)
        return null
      }
      currentItem = foundItem
    }
    return currentItem
  }

  findItemByPath(path: string): APIFileItem | null {
    if (!this.fullFileTree) return null
    if (path === '/' || path === '') return this.fullFileTree

    const pathParts = path.split('/').filter(Boolean)
    let currentItem = this.fullFileTree

    for (const part of pathParts) {
      const items = currentItem.items || []
      const foundItem = items.find((item) => item.name === part)
      if (!foundItem) {
        console.warn('[FileManager] Элемент не найден:', part)
        return null
      }
      currentItem = foundItem
    }
    return currentItem
  }

  addFolderToCache(parentPath: string, folderName: string) {
    if (!this.fullFileTree) return

    const currentDateCreated = this.getCurrentDateCreatedString()
    const currentAuthor = this.getCurrentUserName()

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === folderName && item.isDirectory)) {
        this.fullFileTree.items.push({
          name: folderName,
          isDirectory: true,
          items: [],
          error: false,
          props: {
            date_created: currentDateCreated,
            author: currentAuthor
          }
        })
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + folderName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === folderName && item.isDirectory)) {
        parent.items.push({
          name: folderName,
          isDirectory: true,
          items: [],
          error: false,
          props: {
            date_created: currentDateCreated,
            author: currentAuthor
          }
        })
      }
    }
  }

  updateItemNameInCache(path: string, newName: string): boolean {
    if (!this.fullFileTree) return false
    if (path === '/' || path === '') return false

    const pathParts = path.split('/').filter(Boolean)
    const oldName = pathParts[pathParts.length - 1]
    let item: APIFileItem | undefined

    if (pathParts.length === 1) {
      item = (this.fullFileTree.items || []).find((i) => i.name === oldName)
      if (item) {
        item.name = newName
      }
    } else {
      const parent = this.findParentByPath(path)
      if (parent && parent.items) {
        item = parent.items.find((i) => i.name === oldName)
        if (item) {
          item.name = newName
        }
      }
    }

    if (item) {
      const currentDate = this.getCurrentDateString()
      const currentAuthor = this.getCurrentUserName()
      if (!item.props) {
        item.props = {}
      }
      item.props.date_modified = currentDate
      item.props.author = currentAuthor
      
      const parentPath = pathParts.length === 1 ? '/' : '/' + pathParts.slice(0, -1).join('/')
      this.updateDirectoryDateModified(parentPath)
      
      return true
    }
    return false
  }

  removeFromCache(path: string): boolean {
    if (!this.fullFileTree) return false
    if (path === '/' || path === '') return false

    const pathParts = path.split('/').filter(Boolean)
    const itemName = pathParts[pathParts.length - 1]

    if (pathParts.length === 1) {
      const index = (this.fullFileTree.items || []).findIndex((item) => item.name === itemName)
      if (index !== -1) {
        this.fullFileTree.items?.splice(index, 1)
        return true
      }
      return false
    }

    const parent = this.findParentByPath(path)
    if (parent && parent.items) {
      const index = parent.items.findIndex((item) => item.name === itemName)
      if (index !== -1) {
        parent.items.splice(index, 1)
        return true
      }
    }
    return false
  }

  getCurrentDateString(): string {
    const now = new Date()
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    
    const day = days[now.getDay()]
    const month = months[now.getMonth()]
    const date = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')
    const year = now.getFullYear()
    
    return `${day} ${month} ${date} ${hours}:${minutes}:${seconds} ${year}`
  }

  getCurrentDateCreatedString(): string {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')
    const milliseconds = String(now.getMilliseconds()).padStart(6, '0')
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`
  }

  getCurrentUserName(): string {
    return this.authService.getUserName() || 'Неизвестный пользователь'
  }

  sanitizeItemName(name: string): string {
    return (name || '').replace(/\//g, '')
  }

  updateDirectoryDateModified(directoryPath: string): void {
    if (!this.fullFileTree) return
    
    const currentDate = this.getCurrentDateString()
    const currentAuthor = this.getCurrentUserName()
    const pathParts = directoryPath.split('/').filter(Boolean)
    
    let currentItem: APIFileItem | null = this.fullFileTree
    
    for (let i = 0; i < pathParts.length; i++) {
      const part = pathParts[i]
      if (!currentItem || !currentItem.items) break
      
      const foundItem: APIFileItem | undefined = currentItem.items.find((item) => item.name === part && item.isDirectory)
      if (!foundItem) break
      
      if (!foundItem.props) {
        foundItem.props = {}
      }
      foundItem.props.date_modified = currentDate
      foundItem.props.author = currentAuthor
      
      currentItem = foundItem
    }
  }

  updateItemDateModified(itemPath: string): void {
    if (!this.fullFileTree) return
    
    const currentDate = this.getCurrentDateString()
    const currentAuthor = this.getCurrentUserName()
    const item = this.findItemByPath(itemPath)
    
    if (item) {
      if (!item.props) {
        item.props = {}
      }
      item.props.date_modified = currentDate
      item.props.author = currentAuthor
    }
    const parentPath = itemPath === '/' || itemPath === '' ? '' : itemPath.split('/').slice(0, -1).join('/') || '/'
    this.updateDirectoryDateModified(parentPath)
  }

  getIconByType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase()
    try {
      switch (ext) {
        case 'pdf':
          return require('@/assets/fileicons/pdf.png')
        case 'doc':
        case 'docx':
          return require('@/assets/fileicons/doc.png')
        case 'xls':
        case 'xlsx':
          return require('@/assets/fileicons/xls.png')
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'svg':
          return require('@/assets/fileicons/png.png')
        case 'txt':
          return require('@/assets/fileicons/txt.png')
        case '7z':
        case 'rar':
        case 'tar':
        case 'zip':
          return require('@/assets/fileicons/zip.png')
        case 'ppt':
        case 'pptx':
        case 'pps':
          return require('@/assets/fileicons/ppt.png')
        case 'rtf':
          return require('@/assets/fileicons/rtf.png')
        default:
          return require('@/assets/fileicons/file.png')
      }
    } catch (e) {
      console.warn('[FileManager] Не найдена иконка для расширения:', ext, e)
      return require('@/assets/fileicons/file.png')
    }
  }

  refreshFileManager() {
    if (this.$refs.fileManager) {
      try {
        const fileManager = (this.$refs.fileManager as any)
        const instance = fileManager.instance || fileManager
        
        if (instance) {
          // Обновляем основной вид
          if (instance.refresh) {
            instance.refresh()
          }
          // Обновляем дерево навигации (tree view)
          if (instance._fileItemsView && instance._fileItemsView.refresh) {
            instance._fileItemsView.refresh()
          }
          // Пробуем обновить через провайдер
          if (instance._fileSystemProvider && instance._fileSystemProvider.refresh) {
            instance._fileSystemProvider.refresh()
          }
          // Принудительно перерисовываем
          if (instance.repaint) {
            instance.repaint()
          }
        }
      } catch (e) {
        console.warn('[FileManager] Не удалось обновить менеджер:', e)
      }
    }
  }

  initializeFileSystemProvider() {
    this.fileSystemProvider = new CustomFileSystemProvider({
      getItems: async (parentDirectory: FileSystemItem | null) => {
        try {
          const parentPath = !parentDirectory ? '/' : (parentDirectory.key || '/')
          
          // Если поиск активен и мы в корне - показываем результаты поиска
          if (this.isSearching && parentPath === '/') {
            const searchResults = this.searchInTree(this.searchQuery.trim().toLowerCase())
            this.searchResultsCount = searchResults.length
            
            return searchResults.map((item: APIFileItem & { fullPath: string }) => {
              const itemPath = item.fullPath
              const hasSubDirectories = item.isDirectory && 
                item.items && 
                item.items.length > 0 &&
                item.items.some(subItem => subItem.isDirectory)
              
              const itemSize = item.isDirectory 
                ? this.calculateDirectorySize(item)
                : (item.size !== undefined && item.size !== null 
                    ? item.size 
                    : (item.props?.size ? Number(item.props.size) : 0))

              const sizeDisplay = item.isDirectory 
                ? this.formatFileSize(itemSize)
                : (itemSize > 0 ? this.formatFileSize(itemSize) : '')

              return {
                name: item.name,
                isDirectory: item.isDirectory,
                thumbnail: !item.isDirectory ? this.getIconByType(item.name) : undefined,
                key: itemPath,
                pathKeys: this.getPathKeys(itemPath),
                hasSubDirectories: hasSubDirectories,
                props: {
                  author: this.formatAuthor(item.props?.author),
                  date_modified: this.formatDate(item.props?.date_modified || ''),
                  date_created: this.formatDateCreated(item.props?.date_created || ''),
                  size: sizeDisplay
                }
              }
            })
          }
          
          if (!this.isSearching) {
            this.searchResultsCount = 0
          }
          
          const items = this.findItemsByPath(parentPath)
          
          return items.map((item: APIFileItem) => {
            const itemPath = parentPath === '/' ? `/${item.name}` : `${parentPath}/${item.name}`
            const hasSubDirectories = item.isDirectory && 
              item.items && 
              item.items.length > 0 &&
              item.items.some(subItem => subItem.isDirectory)
            
            const itemSize = item.isDirectory 
              ? this.calculateDirectorySize(item)
              : (item.size !== undefined && item.size !== null 
                  ? item.size 
                  : (item.props?.size ? Number(item.props.size) : 0))

            const sizeDisplay = item.isDirectory 
              ? this.formatFileSize(itemSize)
              : (itemSize > 0 ? this.formatFileSize(itemSize) : '')

            return {
              name: item.name,
              isDirectory: item.isDirectory,
              thumbnail: !item.isDirectory ? this.getIconByType(item.name) : undefined,
              key: itemPath,
              pathKeys: this.getPathKeys(itemPath),
              hasSubDirectories: hasSubDirectories,
              props: {
                author: this.formatAuthor(item.props?.author),
                date_modified: this.formatDate(item.props?.date_modified || ''),
                date_created: this.formatDateCreated(item.props?.date_created || ''),
                size: sizeDisplay
              }
            }
          })
        } catch (e) {
          console.error('[FileManager] Ошибка при получении элементов:', e)
          Message.error('Не удалось загрузить файлы')
          return []
        }
      },

      renameItem: async (item: FileSystemItem, newName: string) => {
        try {
          console.log('Переименование элемента:', item, 'в', newName)
          const rawKey = item.key || ''
          const itemPath = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          const result = await FileManagementService.renameItem(itemPath, newName)
          console.log('Результат переименования:', result)
          if (!result.success) throw new Error(result.message)

          const updated = this.updateItemNameInCache(itemPath, newName)
          
          if (updated) {
            Message.success(`Файл переименован: ${newName}`)
          }

          this.$nextTick(() => {
            this.refreshFileManager()
          })
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при переименовании:', e)
          Message.error('Не удалось переименовать файл')
          return false
        }
      },

      deleteItem: async (item: FileSystemItem) => {
        try {
          const rawKey = item.key || ''
          const itemPath = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey

          if (item.isDirectory) {
            const result = await FileManagementService.deleteFolder(itemPath)
            if (!result.success) throw new Error(result.message)
            this.removeFromCache(itemPath)
            Message.success(`Папка удалена: ${item.name}`)
          } else {
            const result = await FileManagementService.deleteFile(itemPath)
            if (!result.success) throw new Error(result.message)
            this.removeFromCache(itemPath)
            Message.success(`Файл удален: ${item.name}`)
          }
          
          this.$nextTick(() => {
            this.refreshFileManager()
          })
          
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при удалении:', e)
          Message.error(`Не удалось удалить элемент: ${(e as Error).message}`)
          return false
        }
      },

      createDirectory: async (parentDirectory: FileSystemItem | null, name: string) => {
        try {
          const sanitizedName = this.sanitizeItemName(name)
          if (!sanitizedName) {
            Message.warning('Название папки не может быть пустым')
            return false
          }

          const rawKey = parentDirectory?.key || ''
          const cleanKey = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          const parentPath = cleanKey ? cleanKey + '/' : ''
          const items = this.findItemsByPath(parentPath.slice(0, -1) || '/')
          const existingFolder = items.find((item: APIFileItem) => 
            item.name === sanitizedName && item.isDirectory
          )

          if (existingFolder) {
            Message.warning(`Папка "${sanitizedName}" уже существует`)
            return false
          }

          const result = await FileManagementService.createFolder({
            create_path: parentPath,
            folder_name: sanitizedName
          })

          if (!result.success) throw new Error(result.message)
          this.addFolderToCache(parentPath, sanitizedName)
          
          const newFolderPath = parentPath === '/' || parentPath === '' 
            ? `/${sanitizedName}` 
            : `${parentPath}${sanitizedName}`
          this.updateDirectoryDateModified(newFolderPath)
          
          Message.success(`Папка создана: ${sanitizedName}`)
          
          this.$nextTick(() => {
            this.refreshFileManager()
          })
          
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при создании папки:', e)
          Message.error(`Не удалось создать папку: ${(e as Error).message}`)
          return false
        }
      },

      uploadFileChunk: async (fileData: any, uploadInfo: any, destinationDirectory: FileSystemItem | null) => {
  try {
    if (uploadInfo && uploadInfo.chunkIndex > 0) return true
    
    const sanitizedFileName = this.sanitizeItemName(fileData.name || '')
    if (!sanitizedFileName) {
      Message.warning('Название файла не может быть пустым')
      return false
    }

    const uploadFile = sanitizedFileName === fileData.name
      ? fileData
      : new File([fileData], sanitizedFileName, {
          type: fileData.type || 'application/octet-stream',
          lastModified: fileData.lastModified || Date.now()
        })

    const rawKey = destinationDirectory?.key || ''
    const cleanKey = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
    const destPath = cleanKey ? cleanKey : '.'
    const fullPath = destPath === '.' ? sanitizedFileName : destPath + '/' + sanitizedFileName
    const parentPath = destPath === '.' ? '/' : '/' + destPath
    const parentItems = this.findItemsByPath(parentPath)

    const existingFile = parentItems.find((item: APIFileItem) =>
      item.name === sanitizedFileName && !item.isDirectory
    )

    if (existingFile) {
      const confirmed = await new Promise<boolean>((resolve) => {
        this.$confirm(
          `Файл "${sanitizedFileName}" уже существует в папке "${parentPath || '/'}".\n\nЖелаете заменить?`,
          'Файл уже существует',
          {
            confirmButtonText: 'Заменить',
            cancelButtonText: 'Отменить',
            type: 'warning',
            roundButton: true,
          }
        )
          .then(() => resolve(true))
          .catch(() => resolve(false))
      })

      if (!confirmed) {
        Message.info('Загрузка отменена')
        return false
      }

      await FileManagementService.deleteFile(fullPath)
      this.removeFromCache(fullPath)
    }

    const result = await FileManagementService.createFile(uploadFile, destPath)
    if (!result.success) throw new Error(result.message)

    const cached = parentItems.find((item: APIFileItem) =>
      item.name === sanitizedFileName && !item.isDirectory
    )

    if (!cached) {
      this.addFileToCache(parentPath, sanitizedFileName, fileData.size)
    }

    const destDirPath = destPath === '.' ? '/' : destPath
    this.updateDirectoryDateModified(destDirPath)

    Message.success(`Файл загружен: ${sanitizedFileName}`)

    this.$nextTick(() => {
      this.refreshFileManager()
    })

    return true
  } catch (e) {
    console.error('[FileManager] Ошибка при загрузке файла:', e)
    Message.error(`Не удалось загрузить файл: ${(e as Error).message}`)
    return false
  }
},


      abortFileUpload: async (fileData: any, uploadInfo: any, destinationDirectory: FileSystemItem) => {
        try {
          const rawKey = destinationDirectory?.key || ''
          const cleanKey = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          const destPath = cleanKey ? cleanKey : '.'
          const fullPath = destPath === '.' ? fileData.name : destPath + '/' + fileData.name
          
          try {
            await FileManagementService.deleteFile(fullPath)
          } catch (e) {
            console.warn('[FileManager] Не удалось удалить незаконченный upload:', e)
          }
          
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при отмене загрузки:', e)
          return false
        }
      },

      downloadItems: async (items: FileSystemItem[]) => {
        try {
          for (const item of items) {
            try {
              const rawKey = item.key || ''
              const itemPath = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
              await FileManagementService.downloadFile(itemPath)
              Message.success(`Файл ${item.name} загружен`)
            } catch (itemError) {
              console.error('[FileManager] Ошибка при скачивании файла:', item.name, itemError)
              Message.error(`Ошибка при скачивании ${item.name}`)
            }
          }
        } catch (e) {
          console.error('[FileManager] Ошибка при скачивании:', e)
          Message.error('Ошибка при скачивании файлов')
        }
      },

      moveItem: async (item: FileSystemItem, destinationDirectory: FileSystemItem) => {
        try {
          const rawKey = item.key || ''
          const target_path = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          
          const destRawKey = destinationDirectory.key || ''
          const destPath = destRawKey.startsWith('/') ? destRawKey.slice(1) : destRawKey
          const dest_path = destPath ? destPath + '/' + item.name : item.name

          const oldItemPath = rawKey.startsWith('/') ? rawKey : '/' + rawKey
          const oldItem = this.findItemByPath(oldItemPath)

          await FileManagementService.cpMoveItem(target_path, dest_path, true)

          const sourceParentPathParts = target_path.split('/').slice(0, -1)
          const sourceParentPath = sourceParentPathParts.length > 0 
            ? '/' + sourceParentPathParts.join('/') 
            : '/'
          const destParentPath = destPath ? '/' + destPath : '/'

          if (item.isDirectory) {
            this.moveFolderInCache(destPath ? destPath + '/' : '', item.name, oldItem)
          } else {
            this.moveFileInCacheWithDates(destPath ? destPath + '/' : '', item.name, oldItem)
          }
          this.removeFromCache(target_path)
          
          this.updateDirectoryDateModified(sourceParentPath)
          this.updateDirectoryDateModified(destParentPath)
          
          Message.success(`Файл ${item.name} перемещён в ${destPath || '/'}`)
          
          this.$nextTick(() => {
            this.refreshFileManager()
          })
        } catch (e) {
          console.error('[FileManager] Ошибка при перемещении:', e)
          Message.error('Ошибка при перемещении файла')
        }
      },

      copyItem: async (item: FileSystemItem, destinationDirectory: FileSystemItem) => {
        try {
          let newItemName = item.name
          
          const rawKey = item.key || ''
          const target_path = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          
          const destRawKey = destinationDirectory.key || ''
          const destPath = destRawKey.startsWith('/') ? destRawKey.slice(1) : destRawKey

          const oldItemPath = rawKey.startsWith('/') ? rawKey : '/' + rawKey
          const currentItem = this.findItemByPath(oldItemPath)

          const destParentPath = destPath || '/'
          const destItems = this.findItemsByPath(destParentPath)
          while (destItems.some(existingItem => existingItem.name === newItemName)) {
            newItemName = this.addCopySuffix(newItemName)
          }
          const finalDestPath = destPath ? destPath + '/' + newItemName : newItemName

          await FileManagementService.cpMoveItem(
            target_path,
            finalDestPath,
            false
          )

          if (item.isDirectory) {
            this.copyFolderInCache(destPath ? destPath + '/' : '', newItemName, currentItem)
          } else {
            this.addFileToCache(destPath ? destPath + '/' : '', newItemName, item.size || 0)
          }
          
          this.updateDirectoryDateModified(destParentPath)
          
          Message.success(`Файл ${item.name} скопирован в ${destPath || '/'}`)
          
          this.$nextTick(() => {
            this.refreshFileManager()
          })
        } catch (e) {
          console.error('[FileManager] Ошибка при копировании:', e)
          Message.error('Ошибка при копировании файла')
        }
      }
    })
  }

  addCopySuffix(fileName: string): string {
    const dotIndex = fileName.lastIndexOf(".")
    if (dotIndex === -1) {
      return fileName + "_copy"
    }
    const name = fileName.substring(0, dotIndex)
    const ext = fileName.substring(dotIndex)
    return `${name}_copy${ext}`
  }

  moveFolderInCache(parentPath: string, folderName: string, currentFolder: APIFileItem | null) {
    if (!this.fullFileTree) return
    if (!currentFolder) return

    const currentDateCreated = this.getCurrentDateCreatedString()
    const currentDateModified = this.getCurrentDateString()
    const currentAuthor = this.getCurrentUserName()

    const newFolder: APIFileItem = {
      name: folderName,
      isDirectory: true,
      items: currentFolder.items ? Array.from(currentFolder.items) : [],
      error: false,
      props: {
        date_created: currentDateCreated,
        date_modified: currentDateModified,
        author: currentAuthor
      }
    }

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === folderName && item.isDirectory)) {
        this.fullFileTree.items.push(newFolder)
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + folderName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === folderName && item.isDirectory)) {
        parent.items.push(newFolder)
      }
    }
  }

  moveFileInCacheWithDates(parentPath: string, fileName: string, currentFile: APIFileItem | null) {
    if (!this.fullFileTree) return
    if (!currentFile) return

    const currentDateCreated = this.getCurrentDateCreatedString()
    const currentDateModified = this.getCurrentDateString()
    const currentAuthor = this.getCurrentUserName()

    const newFile: APIFileItem = {
      name: fileName,
      isDirectory: false,
      size: currentFile.size !== undefined && currentFile.size !== null 
        ? currentFile.size 
        : (currentFile.props?.size ? Number(currentFile.props.size) : 0),
      error: false,
      props: {
        date_created: currentDateCreated,
        date_modified: currentDateModified,
        author: currentAuthor
      }
    }

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === fileName && !item.isDirectory)) {
        this.fullFileTree.items.push(newFile)
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + fileName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === fileName && !item.isDirectory)) {
        parent.items.push(newFile)
      }
    }
  }

  copyFolderInCache(parentPath: string, folderName: string, currentFolder: APIFileItem | null) {
    if (!this.fullFileTree) return
    if (!currentFolder) return

    const currentDateCreated = this.getCurrentDateCreatedString()
    const currentDateModified = this.getCurrentDateString()
    const currentAuthor = this.getCurrentUserName()

    const newFolder: APIFileItem = {
      name: folderName,
      isDirectory: true,
      items: currentFolder.items ? Array.from(currentFolder.items) : [],
      error: false,
      props: {
        date_created: currentDateCreated,
        date_modified: currentDateModified,
        author: currentAuthor
      }
    }

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === folderName && item.isDirectory)) {
        this.fullFileTree.items.push(newFolder)
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + folderName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === folderName && item.isDirectory)) {
        parent.items.push(newFolder)
      }
    }
  }

  addFileToCache(parentPath: string, fileName: string, fileSize: number = 0) {
    if (!this.fullFileTree) return

    const currentDateCreated = this.getCurrentDateCreatedString()
    const currentDateModified = this.getCurrentDateString()
    const currentAuthor = this.getCurrentUserName()

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === fileName && !item.isDirectory)) {
        this.fullFileTree.items.push({
          name: fileName,
          isDirectory: false,
          size: fileSize,
          error: false,
          props: {
            date_created: currentDateCreated,
            date_modified: currentDateModified,
            author: currentAuthor
          }
        })
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + fileName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === fileName && !item.isDirectory)) {
        parent.items.push({
          name: fileName,
          isDirectory: false,
          size: fileSize,
          error: false,
          props: {
            date_created: currentDateCreated,
            date_modified: currentDateModified,
            author: currentAuthor
          }
        })
      }
    }
  }

  getPathKeys(path: string): string[] {
    return path.split('/').filter(Boolean)
  }

  calculateDirectorySize(directory: APIFileItem): number {
    if (!directory.isDirectory) {
      if (directory.size !== undefined && directory.size !== null) {
        return directory.size
      }
      if (directory.props?.size) {
        const sizeNum = Number(directory.props.size)
        return isNaN(sizeNum) ? 0 : sizeNum
      }
      return 0
    }

    let totalSize = 0
    if (directory.items && directory.items.length > 0) {
      for (const item of directory.items) {
        totalSize += this.calculateDirectorySize(item)
      }
    }
    return totalSize
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B'
    const k = 1024
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i]
  }

  formatAuthor(author: string | null | undefined): string {
    if (!author || author.trim() === '') {
      return 'Автор не известен'
    }
    
    const parts = author.trim().split(/\s+/)
    if (parts.length <= 1) {
      return author
    }
    
    return parts.slice(0, -1).join(' ')
  }

  formatDate(dateString: string): string {
    if (!dateString) return ''
    
    try {
      const dateMatch = dateString.match(/(\w{3})\s+(\w{3})\s+(\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})\s+(\d{4})/)
      
      if (dateMatch) {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const monthName = dateMatch[2]
        const day = dateMatch[3].padStart(2, '0')
        const hours = dateMatch[4]
        const minutes = dateMatch[5]
        const year = dateMatch[7]
        
        const monthIndex = monthNames.indexOf(monthName)
        if (monthIndex === -1) {
          const date = new Date(dateString)
          if (!isNaN(date.getTime())) {
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${day}.${month}.${year} ${hours}:${minutes}`
          }
          return dateString
        }
        
        const month = String(monthIndex + 1).padStart(2, '0')
        return `${day}.${month}.${year} ${hours}:${minutes}`
      }
      
      const date = new Date(dateString)
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${day}.${month}.${year} ${hours}:${minutes}`
      }
      
      return dateString
    } catch (e) {
      console.warn('[FileManager] Ошибка при форматировании даты:', e)
      return dateString
    }
  }

  formatDateCreated(dateString: string): string {
    if (!dateString) return ''
    
    try {
      const dateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})/)
      
      if (dateMatch) {
        const year = dateMatch[1]
        const month = dateMatch[2]
        const day = dateMatch[3]
        const hours = dateMatch[4]
        const minutes = dateMatch[5]
        
        return `${day}.${month}.${year} ${hours}:${minutes}`
      }
      
      const date = new Date(dateString)
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${day}.${month}.${year} ${hours}:${minutes}`
      }
      
      return dateString
    } catch (e) {
      console.warn('[FileManager] Ошибка при форматировании даты создания:', e)
      return dateString
    }
  }

  blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as ArrayBuffer)
      reader.onerror = reject
      reader.readAsArrayBuffer(blob)
    })
  }

  blobToText(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = reject
      reader.readAsText(blob)
    })
  }

  async parseZipArchive(fileBlob: Blob): Promise<string> {
    try {
      const arrayBuffer = await this.blobToArrayBuffer(fileBlob)
      const view = new DataView(arrayBuffer)
      const uint8Array = new Uint8Array(arrayBuffer)

      let contents = 'Содержимое архива:\n\n'
      let fileCount = 0
      let folderCount = 0
      let totalSize = 0

      let endOfCentralDirOffset = -1
      
      for (let i = arrayBuffer.byteLength - 22; i >= 0; i--) {
        if (view.getUint32(i, true) === 0x06054b50) {
          endOfCentralDirOffset = i
          break
        }
      }

      if (endOfCentralDirOffset === -1) {
        throw new Error('Невалидный ZIP файл')
      }

      const centralDirOffset = view.getUint32(endOfCentralDirOffset + 16, true)
      let offset = centralDirOffset

      while (offset < endOfCentralDirOffset) {
        const signature = view.getUint32(offset, true)
        
        if (signature === 0x02014b50) {
          offset += 4
          offset += 2
          offset += 2
          offset += 2
          offset += 2
          offset += 2
          offset += 2
          offset += 4
          offset += 4
          const uncompressedSize = view.getUint32(offset, true)
          offset += 4
          
          const filenameLength = view.getUint16(offset, true)
          offset += 2
          
          const extraFieldLength = view.getUint16(offset, true)
          offset += 2
          
          const fileCommentLength = view.getUint16(offset, true)
          offset += 2
          
          offset += 2
          offset += 2
          offset += 4
          offset += 4
          
          const filenameBytes = uint8Array.slice(offset, offset + filenameLength)
          const filename = new TextDecoder().decode(filenameBytes)
          offset += filenameLength
          
          offset += extraFieldLength + fileCommentLength
          
          if (filename) {
            const isDir = filename.endsWith('/')
            if (isDir) {
              folderCount++
              contents += '📁 ' + filename + '\n'
            } else {
              fileCount++
              totalSize += uncompressedSize
              const sizeKb = (uncompressedSize / 1024).toFixed(2)
              contents += '📄 ' + filename + ' (' + sizeKb + ' KB)\n'
            }
          }
        } else {
          break
        }
      }

      contents += '\n---\n'
      contents += 'Всего файлов: ' + fileCount + '\n'
      contents += 'Всего папок: ' + folderCount + '\n'
      contents += 'Размер: ' + (totalSize / 1024).toFixed(2) + ' KB\n'

      return contents
    } catch (e) {
      console.error('[FileManager] Ошибка при чтении ZIP:', e)
      throw e
    }
  }

  async previewFile(file: any) {
    try {
      const fileName = file.dataItem.name
      const ext = fileName.split('.').pop()?.toLowerCase() || ''
      this.preview.fileName = fileName
      this.preview.type = null
      this.preview.visible = true

      const filePath = (file.dataItem.key || '').replace(/^\//, '')
      const fileBlob = await FileManagementService.downloadFileBlob(filePath)

      if (!fileBlob) throw new Error('Не удалось получить файл')

      // Предпросмотр PDF
      if (['pdf'].includes(ext)) {
        this.preview.type = 'pdf'
        this.preview.pdfSrc = URL.createObjectURL(fileBlob)
        return
      }

      if (['xls', 'xlsx'].includes(ext)) {
        this.preview.type = 'excel'
        try {
          const ExcelJS = await import('exceljs')
          const wb = new ExcelJS.Workbook()
          const buf = await this.blobToArrayBuffer(fileBlob)
          await wb.xlsx.load(buf)
          const ws = wb.worksheets[0]
          
          if (!ws) {
            this.preview.type = 'unsupported'
            Message.error('Excel файл пуст или повреждён')
            return
          }

          const excelRows: {cells: {idx: number, value: any}[], idx:number}[] = []
          ws.eachRow((row: any, rowNumber: number) => {
            const cells: {idx: number, value: any}[] = []
            if (row.values && Array.isArray(row.values)) {
              row.values.forEach((value: any, cellIdx: number) => {
                if (value !== null && value !== undefined && cellIdx > 0) {
                  cells.push({ idx: cellIdx - 1, value: value })
                }
              })
            }
            if (cells.length > 0) {
              excelRows.push({ idx: rowNumber, cells: cells })
            }
          })
          
          this.preview.excelRows = excelRows
          return
        } catch (excelErr) {
          console.error('[FileManager] Ошибка при чтении Excel:', excelErr)
          this.preview.type = 'unsupported'
          Message.error('Ошибка при чтении Excel файла')
          return
        }
      }

      if (['zip'].includes(ext)) {
        this.preview.type = 'archive'
        try {
          this.preview.textContent = await this.parseZipArchive(fileBlob)
          return
        } catch (e) {
          console.error('[FileManager] Ошибка при чтении ZIP:', e)
          this.preview.type = 'unsupported'
          Message.error('Не удалось открыть ZIP архив')
          return
        }
      }

      if (['png', 'jpg', 'jpeg', 'gif', 'svg'].includes(ext)) {
        this.preview.type = 'image'
        this.preview.imageSrc = URL.createObjectURL(fileBlob)
        return
      }

      if (['txt', 'csv', 'json', 'log', 'md'].includes(ext)) {
        this.preview.type = 'text'
        this.preview.textContent = await this.blobToText(fileBlob)
        return
      }
      this.preview.type = 'unsupported'
    } catch (e) {
      console.error('[FileManager] Ошибка предпросмотра файла:', e)
      this.preview.type = 'unsupported'
      Message.error('Ошибка предпросмотра файла: ' + (e as Error).message)
    }
  }

  async onFileOpen(e: any) {
    try {
      const file = e.file
      if (file.dataItem.isDirectory) {
        return
      }

      await this.previewFile(file)
    } catch (e) {
      console.error('[FileManager] Ошибка при открытии файла:', e)
      Message.error('Ошибка при открытии файла')
    }
  }

  onContextMenuClick(e: any) {
    console.log('[FileManager] Контекстное меню:', e)
  }

  onSearchInput(e: any) {
    // Обновляем значение из события input (для совместимости)
    if (e && e.event && e.event.target) {
      this.searchQuery = e.event.target.value
    }
    // Обновляем файловый менеджер сразу
    this.$nextTick(() => {
      this.refreshFileManager()
    })
  }

  async onSearchValueChanged(e: any) {
    // Обрабатываем изменение значения (включая очистку через кнопку)
    // v-model уже обновляет searchQuery, но нужно обновить файловый менеджер
    if (!e || !e.value || e.value.length === 0) {
      // Если значение очищено, сбрасываем счетчик результатов
      this.searchResultsCount = 0
      // Перезагружаем дерево файлов для обновления дерева навигации
      await this.loadFullFileTree()
      // Возвращаемся в корень
      this.$nextTick(() => {
        this.navigateToRoot()
        this.refreshFileManager()
      })
    } else {
      this.$nextTick(() => {
        this.refreshFileManager()
      })
    }
  }

  async clearSearch() {
    this.searchQuery = ''
    this.searchResultsCount = 0
    
    // Перезагружаем дерево файлов для обновления дерева навигации
    await this.loadFullFileTree()
    
    this.$nextTick(() => {
      // Принудительно возвращаемся в корневую директорию
      this.navigateToRoot()
      this.refreshFileManager()
    })
  }

  navigateToRoot() {
    if (this.$refs.fileManager) {
      try {
        const fileManager = (this.$refs.fileManager as any)
        const instance = fileManager.instance || fileManager
        
        if (instance) {
          // Пробуем разные способы навигации
          if (instance.option) {
            instance.option('currentPath', '/')
          }
          if (instance.navigateToDirectory) {
            instance.navigateToDirectory('/')
          } else if (instance.navigateTo) {
            instance.navigateTo('/')
          }
          // Принудительно обновляем дерево навигации
          if (instance._fileItemsView) {
            if (instance._fileItemsView.option) {
              instance._fileItemsView.option('rootFolderName', 'Документы')
            }
            if (instance._fileItemsView.refresh) {
              instance._fileItemsView.refresh()
            }
          }
          // Принудительно обновляем основной вид
          if (instance.refresh) {
            instance.refresh()
          }
        }
      } catch (e) {
        console.warn('[FileManager] Не удалось перейти в корень:', e)
      }
    }
  }

  searchInTree(query: string): (APIFileItem & { fullPath: string })[] {
    if (!this.fullFileTree || !query || query.length < 3) {
      return []
    }

    const results: (APIFileItem & { fullPath: string })[] = []
    
    const searchRecursive = (items: APIFileItem[] | undefined, currentPath: string = '') => {
      if (!items) return

      for (const item of items) {
        const itemName = item.name.toLowerCase()
        if (itemName.includes(query)) {
          const fullPath = currentPath === '' ? `/${item.name}` : `${currentPath}/${item.name}`
          results.push({
            ...item,
            fullPath: fullPath
          })
        }

        // Рекурсивно ищем в подпапках
        if (item.isDirectory && item.items) {
          const nextPath = currentPath === '' ? `/${item.name}` : `${currentPath}/${item.name}`
          searchRecursive(item.items, nextPath)
        }
      }
    }

    if (this.fullFileTree.items) {
      searchRecursive(this.fullFileTree.items, '')
    }

    return results
  }

  onHistoryPopupHidden() {
    this.showHistoryPopup = false
  }

  onHistoryLoad(data: { startDate: Date | null, endDate: Date | null }) {
  }
}
